<div 
   class="tw-w-full tw-max-w-xl lg:tw-max-w-md tw-mx-auto tw-px-4" 
   [ngClass]="{ 
      'tw-pb-10': !isInsidePopup(),
      'lg:tw-py-12 tw-flex tw-items-center tw-h-full': isInsidePopup() 
   }"
>
   <app-otp-verification 
      verifyType="email" 
      [isInsidePopup]="isInsidePopup()"
      [identifierText]="email()"
      [isLoading]="isLoading()"
      [isResending]="isResending()"
      [errorMessage]="errorMessage()"
      (verify)="onVerify($event)"
      (resend)="resendOtp()"
      (editIdentifier)="editEmail()"
      (goBack)="goBack()">
   </app-otp-verification>
</div>
